export default __webpack_public_path__ + "static/media/header_image.323d9311.jpg";